import { render, staticRenderFns } from "./Obras.vue?vue&type=template&id=376c4792&scoped=true&"
import script from "./Obras.vue?vue&type=script&lang=js&"
export * from "./Obras.vue?vue&type=script&lang=js&"
import style0 from "./Obras.vue?vue&type=style&index=0&id=376c4792&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376c4792",
  null
  
)

export default component.exports